import { useOrientation } from "@/common/hooks/useOrientation";
import { useGetUserData } from "@/common/hooks/useGetUserData";
import { useTrackVisit } from "@/common/hooks/useTrackVisit";

import { useAppStyles } from "@/components/app/AppHooks/hooks/useAppStyles";
import { useInitDocumentTitle } from "@/components/app/AppHooks/hooks/useInitDocumentTitle";
import { useFullScreen } from "@/components/app/AppHooks/hooks/useFullScreen";
import { useTrackUser } from "@/components/app/AppHooks/hooks/useTrackUser";
import { useScroll } from "@/components/app/AppHooks/hooks/useScroll";
import { useGTM } from "@/components/app/AppHooks/hooks/useGTM";
import { useDetectGeolocation } from "@/components/app/AppHooks/hooks/useDetectGeolocation";
import { useTrackCookieConsent } from "@/components/app/AppHooks/hooks/useTrackCookieConsent";
import { useAgeVerificationStatusPopup } from "@/components/app/AppHooks/hooks/useAgeVerificationStatusPopup";

export const AppHooks = () => {
  useGetUserData();
  useDetectGeolocation();

  useTrackVisit();
  useAppStyles();
  useInitDocumentTitle();
  useAgeVerificationStatusPopup();
  useFullScreen();
  useTrackUser();
  useOrientation();
  useScroll();
  useTrackCookieConsent();
  useGTM();

  return null;
};
